// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { maxWidth, minWidth, width } from '@mui/system';

const getLabelComponentWidth = (widthnew: any) => {
  let labelWidth = '15%';
  const tempWidth = widthnew;
  if (tempWidth >= 300 && tempWidth <= 400) {
    labelWidth = '25%';
  } else if (tempWidth >= 500 && tempWidth <= 600) {
    labelWidth = '15%';
  } else if (tempWidth >= 900 && tempWidth <= 1500) {
    labelWidth = '8%';
  }

  return labelWidth;
};
const styles = {
  labeldiv: (widthnew: any) => ({
    position: 'absolute',
    transform: 'translate(-50%, -110%)',
    background: '#eaeef0ff',
    pointerEvents: 'auto',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
    border: '3px solid rgba(246, 248, 250, 1)',
    padding: '2px 4px',
    color: '#ffffff',
    width: getLabelComponentWidth(widthnew),
    whitespace: 'normal',
    wordbreak: 'break-word',
    textAlign: 'center',
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 200,
    zIndex: 10000,
  }),
  labelRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  labelContainer: {
    border: 'none',
    outline: 'none',
    width: '80px',
    fontSize: '10px',
    textAlign: 'center',
    background: 'transparent',
  },
  labelTextSpan: {
    display: 'block',
    width: '100%',
    background: '#01A1DD',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    border: '1px solid rgba(246, 248, 250, 1)',
    borderRadius: '6px',
  },
  EditPencil: {
    cursor: 'pointer',
    width: '20%',
  },
  CloseIcon: {
    cursor: 'pointer',
    width: '20%',
  },
  labelEditDiv: {
    display: 'flex',
    justifyContent: 'center',
    margintop: '0px',
    marginbottom: '3px',
    gap: '4px',
    border: '1px solid rgba(222, 229, 235, 1)',
    borderRadius: '6px',
  },
  labelMarker: (color: string) => ({
    position: 'absolute',
    bottom: '-20px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '2px',
    height: '20px',
    backgroundColor: color,
  }),
  labelIcons: {
    cursor: 'pointer',
    color: '#f7fafbff',
    width: '70%',
    height: '80%',
  },
  ColorDiv: (color: string) => ({
    width: '21%',
    borderRadius: '16px',
    border: `1px solid ${color || '#ccc'}`,
    backgroundColor: color || '#ccc',
    cursor: 'pointer',
  }),
  paletteContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 20px)',
    gap: '6px',
    padding: '6px',
    background: 'white',
    border: '1px solid #ccc',
    borderRadius: '6px',
    position: 'absolute',
    marginTop: '-60px',
    zIndex: 9999999,
  },
  paletteColor: (color: string) => ({
    width: '20px',
    height: '20px',
    backgroundColor: color,
    borderRadius: '16px',
    border: '1px solid #888',
    cursor: 'pointer',
  }),
  IconDiv: {
    width: '80%',
    display: 'flex',
    gap: '4px',
  },

};
export default styles;
